import React from "react";

// Components
import { IonRouterLink } from "@ionic/react";
import ImageAthleteProfile from "../Images/ImageAthleteProfile";
// import ImageFlag from "../Images/ImageFlag";
import { debug } from "../../App";
import DateLastActive from "../DateTime/DateLastActive";
import MemberChatLink from "./MemberChatLink";
import MemberNotesLink from "./MemberNotesLink";
import MemberStatus from "./MemberStatus";

export default class MembersTableRow extends React.Component<any, any> {
  render() {
    const { member } = this.props;
    debug("MembersTableRow: Rendering", member);

    return (
      <tr>
        <td className="members-table__athlete-profile-image">
          <ImageAthleteProfile user={member} />
        </td>
        <td className="members-table__athlete-name">
          <IonRouterLink className="members-table__athlete-name__link" routerLink={`/admin/members/${member?.id}`} title={member?.user?.email}>
            {member?.nickname || `${member.first_name} ${member.last_name}` || member?.user?.email || `Member ${member.id}`}
          </IonRouterLink>
        </td>
        <td className="members-table__athlete-status">
          <MemberStatus {...this.props} />
        </td>
        <td className="members-table__athlete-last-active">
          {/* @ts-ignore */}
          <DateLastActive date={member.last_seen} />
        </td>
        <td className="members-table__athlete-notes">
          <div>
            <MemberChatLink {...this.props} />
            <MemberNotesLink user={member} />
          </div>
        </td>
      </tr>
    );
  }
}
